import React, { useState, useEffect } from "react";
import { Icon, Text } from "blueprints2";
import { FormattedMessage } from "react-intl";

function UserHistoryList({ userHistory }) {
  const [history, setHistory] = useState(userHistory);

  useEffect(() => {
    setHistory(userHistory);
  }, [userHistory]);

  return (
    <div>
      <FormattedMessage id="settings.user.history.title" />
      <div className="applications-list">
        {history.map((item, i) => {
          return (
            <Text key={i}>
              <Icon type="chevron-right" title="Event" />
              {`${item.date} |
              ${item.name}`}
            </Text>
          );
        })}
      </div>
    </div>
  );
}

export default UserHistoryList;
